import BaseSetup from '@/components/BaseSetup';

export type SharedListQuickFilterEmits = {};
export type SharedListQuickFilterProps = {
	displaySearch?: boolean
	hideTagFilter?: boolean
	filterService: PagedListFilterServiceList
};

export default class SharedListQuickFilterSetup extends BaseSetup {

	static readonly defaultProps = {};

	get filter () { return this.props.filterService.filter as PagedListFilter }
	get quickFilters () { return this.props.filterService.quickFilters as ListQuickFilter<PagedListFilter>[] }

	constructor (
		private props: SharedListQuickFilterProps,
		private emits: SharedListQuickFilterEmits,
	) {
		super();
	}

	getQuickFilterColor (quickFilter: ListQuickFilter<PagedListFilter>) {
		return quickFilter?.active() ? 'info' : 'default' as Orion.Color;
	}

	applyQuickFilter (quickFilter: ListQuickFilter<PagedListFilter>) {
		const filterKey = quickFilter?.filterKey as keyof typeof this.filter;
		if (!filterKey) return;

		if (quickFilter?.active()) {
			if (filterKey !== 'page' && (filterKey as string) !== 'research') {
				const filterValue = quickFilter?.filterValue;
				if (typeof filterValue === 'function') {
					(this.filter[filterKey] as PagedListFilter[keyof PagedListFilter]) = filterValue();
				}
				else {
					this.props.filterService.setOriginalFilterKeyValue(filterKey as any);
				}
			}
		}
		else if (quickFilter) {
			const filterValue = quickFilter?.filterValue;
			if (typeof filterValue === 'function') {
				(this.filter[filterKey] as PagedListFilter[keyof PagedListFilter]) = filterValue();
			}
			else {
				(this.filter[filterKey] as PagedListFilter[keyof PagedListFilter]) = filterValue;
			}
		}

		this.props.filterService.applyWithRouterAsync(true);
	}

}
